import { useMutation } from '@tanstack/react-query'
import { putPaymentSupportCase } from 'services/PaymentsService'

export const usePutPaymentCaseMutation = () => {
  return useMutation({ mutationFn: putPaymentSupportCase })
}
